'use strict';

import angular from 'angular';

export default class MemContactCtrl {
  constructor($stateParams, ToastrSvc, MemberSvc) {
    var that = this;
    var groupId = $stateParams.ctxId; // use context group

    this.emailTypes = ['Personal', 'Work'];
    this.numberTypes = ['Mobile', 'Work', 'Home', 'Fax'];
    this.addressTypes = ['Home', 'Work'];

    this.edit = function(person) {
      that.person = person;
      that.model = angular.copy(person);

      // convert to object for angular forms
      // leaving as a string causes unusual ngModel behavior
      if(that.model.addresses) {
        that.model.addresses = that.model.addresses.map(function(a) {
          a.lines = a.lines.map(function(line) {
            return {line};
          });
          return a;
        });
      }

      that.showForm = true;
    };

    this.view = function() {
      if(that.person) { that.model = angular.copy(that.person); }
      that.showForm = false;
    };

    this.addEmail = function() {
      if(!that.model.emails) {
        that.model.emails = [];
      }
      that.model.emails.push({});
    };

    // remove duplicate email error if updated
    that.changeEmail = function() {
      if(that.duplicateEmailsError) {
        that.duplicateEmailsError = false;
      }
    };

    this.addNumber = function() {
      if(!that.model.numbers) {
        that.model.numbers = [];
      }
      that.model.numbers.push({});
    };

    this.addLine = function(address) {
      address.lines.push({});
    };

    this.addAddress = function() {
      if(!that.model.addresses) {
        that.model.addresses = [];
      }
      that.model.addresses.push({lines: [{}]});
    };

    this.removeEmail = function(index) {
      if(!that.model.emails) { return; }
      that.model.emails.splice(index, 1);
    };

    this.removeNumber = function(index) {
      if(!that.model.numbers) { return; }
      that.model.numbers.splice(index, 1);
    };

    this.removeAddress = function(index) {
      if(!that.model.addresses) { return; }
      that.model.addresses.splice(index, 1);
    };

    this.removeAddressLine = function(address, index) {
      if(address.lines) {
        address.lines.splice(index, 1);
      }
    };

    this.contactSubmitted = false;

    this.cancel = function(form) {
      form.$setPristine();
      that.contactSubmitted = false;
      that.showForm = false;
      that.duplicateEmailsError = false;
      that.model = angular.copy(that.person);
    };

    this.update = function(form) {
      that.contactSubmitted = true;
      that.duplicateEmailsError = false;
      if(form.$valid) {
        that.duplicateEmailsError = false;
        var personId = that.model.id;
        var updatePerson = {
          id: personId,
          fname: that.model.fname, // required for person model
          lname: that.model.lname, // required for person model
          emails: angular.copy(that.model.emails),
          numbers: angular.copy(that.model.numbers),
          addresses: angular.copy(that.model.addresses),
        };

        // convert back to simple array of strings
        if(updatePerson.addresses) {
          updatePerson.addresses = updatePerson.addresses.map(function(a) {
            a.lines = a.lines.map(function(line) {
              return line.line;
            });
            return a;
          });
        }

        MemberSvc.updatePerson({groupId, id: updatePerson.id}, updatePerson)
          .$promise
          .then(function() {
            form.$setPristine();
            angular.extend(that.person, updatePerson);
            that.showForm = false;
            that.contactSubmitted = false;
            ToastrSvc.success('Contact Information Updated');
          })
          .catch(function(err) {
            var emailErr = 'The specified email address is already in use.';
            if(err.data === emailErr) {
              that.duplicateEmailsError = true;
            }
          });
      }
    };
  }
}

MemContactCtrl.$inject = ['$stateParams', 'ToastrSvc', 'MemberSvc'];
